export default {
    mercuryflooring: {
        defaultOperator: '/pp/forms',
        defaultRedirection: '/dashboard',
    },

    printconcept: {
        defaultOperator: '/dashboard',
        defaultRedirection: '/dashboard',
    },
};
